import api from "@/api/api-v1-config";

export async function getBankAxios() {    
    return await api.get("v1/banks/bank");
}

export async function getBankIDAxios(id) {    
    return await api.get("v1/banks/"+ id);
}

export async function deleteBankAxios(id) {    
    return await api.delete("v1/banks?Id=" + id);
}

export async function postBankAxios(bank) {    
    return await api.post("v1/banks/bank", bank);
}

export async function putBankAxios(bank) {    
    return await api.put("v1/banks/", bank);
}

